const RegenerateMerchantAPIKey = ({
  regenerate,
  setRegenerate,
  regenerateAPIkey,
}) => {
  return (
    <div
      className={regenerate === true ? "modal fade show d-block" : "modal fade"}
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content text-center bg-success text-light">
          <div className="modal-header">
            <h5 className="modal-title mx-auto text-light">REGENERATE</h5>
          </div>
          <div className="modal-body">
            <p className="h4 text-light">Are You Sure ?</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              onClick={() => {
                setRegenerate((prev) => !prev);
              }}
              type="button"
              className="btn btn-light btn-sm"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <button
              onClick={() => {
                setRegenerate((prev) => !prev);
                regenerateAPIkey();
              }}
              type="button"
              className="btn btn-light btn-sm"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegenerateMerchantAPIKey;
